module.exports = __webpack_public_path__ + "static/startupinspector.7f891aa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/startupinspector/startupinspector.jpg
// module id = 761
// module chunks = 102538987983895